'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dImpersonator from "./presto.types$-Impersonator.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Impersonator$() {
}
export { $c_Lpresto_types$Impersonator$ as $c_Lpresto_types$Impersonator$ };
$p = $c_Lpresto_types$Impersonator$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Impersonator$;
/** @constructor */
function $h_Lpresto_types$Impersonator$() {
}
export { $h_Lpresto_types$Impersonator$ as $h_Lpresto_types$Impersonator$ };
$h_Lpresto_types$Impersonator$.prototype = $p;
$p.l = (function() {
  return "Impersonator";
});
$p.cFX = (function(x$0) {
  return new $j_presto$002etypes$0024$002dImpersonator.$c_Lpresto_types$Impersonator($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1));
});
var $d_Lpresto_types$Impersonator$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Impersonator$, "presto.types$Impersonator$", ({
  a0T: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$Impersonator$ as $d_Lpresto_types$Impersonator$ };
var $n_Lpresto_types$Impersonator$;
function $m_Lpresto_types$Impersonator$() {
  if ((!$n_Lpresto_types$Impersonator$)) {
    $n_Lpresto_types$Impersonator$ = new $c_Lpresto_types$Impersonator$();
  }
  return $n_Lpresto_types$Impersonator$;
}
export { $m_Lpresto_types$Impersonator$ as $m_Lpresto_types$Impersonator$ };
//# sourceMappingURL=presto.types$-Impersonator$.js.map
